var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"secondary--text mx-6 my-16 text-center"},[_vm._v(" Gracias por tu interés en formar parte del equipo TIDINGO."),_c('br'),_vm._v(" En estos momentos no tenemos posiciones disponibles. ")])])
}]

export { render, staticRenderFns }